import(/* webpackMode: "eager" */ "/var/www/pediloo/app/error.tsx");
